import { t } from "@lingui/macro";
import React from "react";

import { CalendarIcon } from "../../../../icons_v2/general";
import { Center, HStack, Pressable, Text } from "../../../../primitive";

type Props = {
  setIsOpen: (arg: boolean) => void;
  isOpen: boolean;
  currentValueString: string;
};

export const DateRangeTrigger = ({
  setIsOpen,
  isOpen,
  currentValueString,
}: Props) => {
  return (
    <Pressable
      accessibilityHint={t`date range picker`}
      aria-label={t`date range picker`}
      testID="date-range-picker"
      backgroundColor="text-inverse"
      onPress={() => {
        setIsOpen(!isOpen);
      }}
    >
      <HStack
        borderColor="surface-dividers"
        style={{
          alignItems: "center",
          borderWidth: 1.5,
          borderRadius: 8,
          paddingHorizontal: 16,
          paddingVertical: 14,
          height: 50,
        }}
      >
        <Text style={{ flex: 1 }} variant={"mainSmallSemiBold"}>
          {currentValueString}
        </Text>
        <Center marginLeft={3}>
          <CalendarIcon />
        </Center>
      </HStack>
    </Pressable>
  );
};
